<template>
  <FilterCredit v-if="modalShowFilterTransaction" @closeModal="closeModal" @submitFilter="submitFilter"
    :customerOption="customerOption" />
  <ConfirmDialog group="headless">
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded">
        <div
          class="rounded-full bg-white outline outline-black inline-flex justify-center items-center h-24 w-24 -mt-20">
          <i class="pi pi-question text-5xl"></i>
        </div>
        <span class="font-bold text-2xl block mb-2 mt-6">{{ message.header }}</span>
        <p class="mb-0">{{ message.message }}</p>
        <div class="flex items-center gap-2 mt-6">
          <Button :label="message.rejectLabel" outlined @click="rejectCallback" class="w-32"></Button>
          <Button :label="message.acceptLabel" @click="acceptCallback" class="w-32"></Button>
        </div>
      </div>
    </template>
  </ConfirmDialog>
  <Pelunasan v-if="modalShowPelunasan" @closeModal="closeModalPelunasan" :credit="selectedCredit"
    @submitPelunasan="submitPelunasan" />
  <IndexView />
  <section class="p-6">
    <PageTitle title="Riwayat Piutang" />
    <div class="bg-white dark:bg-dark-900 w-full rounded-lg py-6 px-5 shadow-lg">
      <div id="table-header" class="mb-5 flex justify-between items-end">
        <div class="mb-5 flex justify-between gap-3">
          <AddButton to_url="#" button_text="Filter" button_class="text-base py-2 font-medium" @click="showModal" />
          <AddButton to_url="#" button_text="Print Laporan" button_class="text-base py-2 font-medium"
            @click="printAccountsReceivableReport" />
        </div>
      </div>
      <div v-if="isLoading" class="flex justify-center items-center py-4">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
      </div>
      <div v-else class="overflow-x-auto">
        <div class="inline-block min-w-full align-middle">
          <div class="overflow-hidden shadow-lg rounded-lg">
            <TableComponent>
              <TableHead>
                <TableRow>
                  <TableHeadCell>No</TableHeadCell>
                  <TableHeadCell>Pelunasan</TableHeadCell>
                  <TableHeadCell>Status</TableHeadCell>
                  <TableHeadCell>Kode</TableHeadCell>
                  <TableHeadCell>Nama Pelanggan</TableHeadCell>
                  <TableHeadCell>Order Type</TableHeadCell>
                  <TableHeadCell>Meja</TableHeadCell>
                  <TableHeadCell>Penanggung Jawab</TableHeadCell>
                  <TableHeadCell>Metode pembayaran</TableHeadCell>
                  <TableHeadCell>Sub Total</TableHeadCell>
                  <TableHeadCell>tax</TableHeadCell>
                  <TableHeadCell>Service Charge</TableHeadCell>
                  <TableHeadCell>Diskon</TableHeadCell>
                  <TableHeadCell>Grand Total</TableHeadCell>
                  <TableHeadCell>Keterangan</TableHeadCell>
                  <TableHeadCell>Bayar</TableHeadCell>
                  <TableHeadCell>Waktu Transaksi</TableHeadCell>
                  <TableHeadCell>Status</TableHeadCell>
                  <TableHeadCell>Cash Register</TableHeadCell>
                  <TableHeadCell>Action</TableHeadCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow v-for="transaction in this.allSalesOrders" :key="transaction.id">
                  <TableCell>
                    {{ transaction.id }}
                  </TableCell>
                  <TableCell>
                    <Button v-if="!transaction.is_paid_off" label="Lunaskan" severity="success" @click="() => {
                      selectedCredit = transaction;
                      modalShowPelunasan = true;
                    }" />
                    <Button v-else label="Print Bill" severity="info" @click="printBillCredit(transaction)" />

                  </TableCell>
                  <TableCell>
                    <span :class="{
                      'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-300': transaction.is_paid_off,
                      'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-300': !transaction.is_paid_off
                    }" class="px-2 py-1 rounded-full text-xs font-medium">
                      {{ transaction.is_paid_off ? "LUNAS" : "BELUM LUNAS" }}
                    </span>
                  </TableCell>
                  <TableCell>
                    {{ transaction.code }}
                  </TableCell>
                  <TableCell>
                    {{ transaction.customer_name }}
                  </TableCell>
                  <TableCell>
                    {{ transaction.order_type }}
                  </TableCell>
                  <TableCell>
                    {{this.allTables?.find(t => t.id == transaction.table_id)?.name}}
                  </TableCell>
                  <TableCell>
                    {{this.allMarketings?.find(m => m.id == transaction.marketing_id)?.name}}
                  </TableCell>
                  <TableCell>
                    {{this.allPaymentMethods?.find(pm => pm.id == transaction.payment_method_id)?.name}}
                  </TableCell>
                  <TableCell>
                    {{ formatRupiah(transaction.sub_total) }}
                  </TableCell>
                  <TableCell>
                    {{ formatRupiah(transaction.tax) }}
                  </TableCell>
                  <TableCell>
                    {{ formatRupiah(transaction.service_charge) }}
                  </TableCell>
                  <TableCell>
                    {{ formatRupiah(transaction.global_discount_amount) }}
                  </TableCell>
                  <TableCell>
                    {{ formatRupiah(transaction.grand_total) }}
                  </TableCell>
                  <TableCell>
                    {{ transaction.note }}
                  </TableCell>
                  <TableCell>
                    {{ formatRupiah(transaction.payment_amount) }}
                  </TableCell>
                  <TableCell>
                    {{ formatDate(transaction.createdAt) }}
                  </TableCell>
                  <TableCell>
                    {{ transaction.status }}
                  </TableCell>
                  <TableCell>
                    {{ formatDate(transaction.cash_register.time_start) }}
                  </TableCell>
                  <TableCell>
                    <RouterLink :to="{ path: '/order', query: { orderId: transaction.id } }"
                      class="border border-gray-400 hover:border-green-700 hover:bg-green-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                      <ShoppingCartIcon class="h-5 w-5" />
                    </RouterLink>
                    <RouterLink :to="{ path: '/payment', query: { orderId: transaction.id } }"
                      class="border border-gray-400 hover:border-blue-700 hover:bg-blue-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                      <EyeIcon class="h-5 w-5" />
                    </RouterLink>
                  </TableCell>
                </TableRow>
              </TableBody>
            </TableComponent>
            <PaginationButtons v-model="currentPage" :totalPages="totalPages" />
          </div>
          <Accordion>
            <AccordionPanel value="0">
              <AccordionHeader>Ringkasan Hutang</AccordionHeader>
              <AccordionContent>
                <div class="mt-6 bg-white dark:bg-dark-800 p-4 rounded-lg shadow">
                  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                    <div class="bg-gray-50 dark:bg-dark-700 p-4 rounded">
                      <p class="text-sm text-gray-500 dark:text-gray-400">Total Transaksi</p>
                      <p class="text-xl font-semibold">{{ allSalesOrders.length }}</p>
                    </div>
                    <div class="bg-gray-50 dark:bg-dark-700 p-4 rounded">
                      <p class="text-sm text-gray-500 dark:text-gray-400">Total Hutang</p>
                      <p class="text-xl font-semibold">{{ formatRupiah(totalCredit) }}</p>
                    </div>
                    <div class="bg-gray-50 dark:bg-dark-700 p-4 rounded">
                      <p class="text-sm text-gray-500 dark:text-gray-400">Total Belum Terbayar</p>
                      <p class="text-xl font-semibold">{{ formatRupiah(totalNotPaidOff) }}</p>
                    </div>
                    <div class="bg-gray-50 dark:bg-dark-700 p-4 rounded">
                      <p class="text-sm text-gray-500 dark:text-gray-400">Total Sudah Terbayar</p>
                      <p class="text-xl font-semibold">{{ formatRupiah(totalPaidOff) }}</p>
                    </div>
                    <div class="bg-gray-50 dark:bg-dark-700 p-4 rounded">
                      <p class="text-sm text-gray-500 dark:text-gray-400">Total Pax</p>
                      <p class="text-xl font-semibold">{{ totalPax }}</p>
                    </div>
                  </div>
                </div>
              </AccordionContent>
            </AccordionPanel>
          </Accordion>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import PageTitle from "@/components/PageTitle.vue";
  import IndexView from "@/views/IndexView.vue";
  import { EyeIcon, ShoppingCartIcon } from "@heroicons/vue/24/solid";
  import AddButton from "@/components/buttons/AddButton.vue";
  import { mapActions, mapGetters } from "vuex";
  import PaginationButtons from "@/components/PaginationButtons.vue";
  import { TableComponent } from "@/components/table";
  import TableHead from "@/components/table/TableHead.vue";
  import TableBody from "@/components/table/TableBody.vue";
  import TableRow from "@/components/table/TableRow.vue";
  import TableCell from "@/components/table/TableCell.vue";
  import TableHeadCell from "@/components/table/TableHeadCell.vue";
  import { Accordion, AccordionPanel, AccordionContent, AccordionHeader, Button, ConfirmDialog } from "primevue";
  import FilterCredit from "./modals/FilterCredit.vue";
  import print from "@/helpers/print";
  import { formatRupiah } from "@/helpers/formatRupiah";
  import axios from "axios";
  import Pelunasan from "./modals/Pelunasan.vue";
  import printPdf from "@/helpers/printPdf";
  import { formatDate } from "@/helpers/formatTime";


  export default {
    name: "CreditView",
    components: {
      PageTitle,
      IndexView,
      ShoppingCartIcon,
      AddButton,
      EyeIcon,
      PaginationButtons,
      TableComponent,
      TableHead,
      TableBody,
      TableRow,
      TableCell,
      TableHeadCell,
      Button,
      ConfirmDialog,
      FilterCredit,
      Pelunasan,
      Accordion,
      AccordionPanel,
      AccordionContent,
      AccordionHeader,
    },
    data() {
      return {
        modalShowFilterTransaction: false,
        isBlur: false,
        listTransaction: [],
        socket: null,
        message: "",
        messages: [],
        isLoading: false,
        currentPage: 1,
        totalPages: 1,
        filter: {},
        modalShowPelunasan: false,
        selectedCredit: null,
      };
    },
    async created() {
      this.fetchSalesOrders();
      this.fetchAdditionalData();
    },
    computed: {
      ...mapGetters('sales_orders', ['allSalesOrders']),
      ...mapGetters('tables', ['allTables']),
      ...mapGetters('marketings', ['allMarketings']),
      ...mapGetters('payment_methods', ['allPaymentMethods']),
      totalCredit() {
        return this.allSalesOrders.reduce((total, credit) => total + Number(credit.grand_total), 0);
      },
      totalPaidOff() {
        return this.allSalesOrders.filter(credit => credit.is_paid_off).reduce((total, credit) => total + Number(credit.grand_total), 0);
      },
      totalNotPaidOff() {
        return this.allSalesOrders.filter(credit => !credit.is_paid_off).reduce((total, credit) => total + Number(credit.grand_total), 0);
      },
      totalPax() {
        return this.allSalesOrders.reduce((total, credit) => total + credit.pax, 0);
      },
      customerOption() {
        const uniqueCustomers = new Map();
        this.allSalesOrders.forEach(item => {
          if (item.customer_name && !uniqueCustomers.has(item.customer_name)) {
            uniqueCustomers.set(item.customer_name, {
              name: item.customer_name,
              id: item.customer_name
            });
          }
        });
        return Array.from(uniqueCustomers.values());
      }
    },
    watch: {
      currentPage: {
        immediate: true,
        handler(newVal) {
          this.fetchSalesOrders({ page: newVal });
        },
      },
    },
    methods: {
      ...mapActions('sales_orders', ['updateSalesOrder']),
      formatRupiah,
      formatDate,
      formateISODate(date) {
        const localDate = new Date(date);
        const offset = localDate.getTimezoneOffset();
        const adjustedDate = new Date(localDate.getTime() - (offset * 60 * 1000));
        return adjustedDate.toISOString().split('T')[0];
      },
      async fetchSalesOrders(params = {}) {
        if (!params.page) params.page = this.currentPage;
        if (!params.limit) params.limit = 50;
        params.is_credit = true;
        try {
          const { pagination } = await this.$store.dispatch('sales_orders/fetchSalesOrders', params);
          if (pagination) {
            this.totalPages = pagination.totalPages;
          }
        } catch (error) {
          console.log(error);
        }
      },
      async fetchAdditionalData() {
        this.$store.dispatch('tables/fetchTables', { limit: 1000 });
        this.$store.dispatch('marketings/fetchMarketings', { limit: 1000 });
        this.$store.dispatch('payment_methods/fetchPaymentMethods', { limit: 1000 });
      },
      showModal() {
        this.modalShowFilterTransaction = true;
        this.isBlur = true;
      },
      closeModal() {
        setTimeout(() => {
          this.modalShowFilterTransaction = false;
          this.isBlur = false;
        }, 200);
      },
      submitFilter(filter) {
        this.filter = filter;
        let params = {};

        if (this.filter.capacity) {
          params.capacity = this.filter.capacity;
        }

        if (this.filter.type) {
          params.order_type = this.filter.type;
        }

        if (this.filter.status) {
          params.is_paid_off = this.filter.status === '1' ? true : false;
        }

        if (this.filter.marketing_id) {
          params.marketing_id = this.filter.marketing_id;
        }

        if (this.filter.payment_method_id) {
          params.payment_method_id = this.filter.payment_method_id;
        }

        if (this.filter.table_id) {
          params.table_id = this.filter.table_id;
        }

        if (this.filter.cash_register_id) {
          params.cash_register_id = this.filter.cash_register_id;
        }

        if (this.filter.customer_name) {
          params.customer_name = this.filter.customer_name;
        }

        if (this.filter.rangeDate) {
          const start_date = this.formateISODate(this.filter.rangeDate[0]);
          const end_date = this.formateISODate(this.filter.rangeDate[1]);
          params.start_date = start_date;
          params.end_date = end_date;
          params.date_column = 'createdAt';
        }

        params.is_credit = true;

        this.fetchSalesOrders(params);
        this.updateFilter(filter);
      },
      updateFilter(filter) {
        this.filter = filter;
      },
      submitPelunasan(transaction) {
        this.$confirm.require({
          group: 'headless',
          header: 'Apakah tagihan ini sudah lunas?',
          message: 'Silahkan konfirmasi sebelum diproses.',
          acceptLabel: 'Ya',
          rejectLabel: 'Tidak',
          accept: async () => {
            try {
              await this.updateSalesOrder({ id: transaction.id, is_paid_off: true, transaction_type_id: transaction.transaction_type_id, order_type: transaction.order_type, table_id: transaction.table_id, note_credit: transaction?.note_credit });
              this.fetchSalesOrders();
              this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Berhasil melunaskan tagihan.', life: 3000 });

              await this.printBillCredit(transaction);
            }
            catch (error) {
              console.error('Gagal melunaskan tagihan.', error);
              this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Gagal melunaskan tagihan.', life: 3000 });
            }
          },
          reject: () => {
            this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Batal melunaskan tagihan.', life: 3000 });
          }
        });
      },
      async formatBillCredit(transaction) {
        let printerText = ``;
        const rows = [];

        try {
          const cashier = transaction?.update_by ? await this.$store.dispatch("users/fetchUserById", transaction?.update_by) : null;
          // Add company header with center alignment
          rows.push("\x1b\x61\x01"); // Center alignment
          rows.push(process.env.VUE_APP_STORE_NAME);
          rows.push(process.env.VUE_APP_STORE_ADDRESS);
          rows.push(process.env.VUE_APP_STORE_PHONE);
          rows.push(print.breakLine(40, "="));

          rows.push(print.twoColumn(`Kode :`, `${transaction?.code}`, 17, 6, 17));
          rows.push(print.twoColumn(`Tanggal :`, `${this.formatDate(transaction?.updatedAt)}`, 17, 6, 17));
          rows.push(print.twoColumn(`Pelanggan :`, `${transaction?.customer_name}`, 17, 6, 17));
          rows.push(print.twoColumn(`Kasir :`, `${cashier?.data?.name}`, 17, 6, 17));
          rows.push(print.twoColumn(`Total Piutang :`, `${formatRupiah(transaction?.grand_total)}`, 17, 6, 17));
          rows.push(print.twoColumn(`Status :`, `PAID`, 17, 6, 17));

          rows.push(print.breakLine(40, "="));

          rows.push(print.oneLine(`Detail Pembayaran :`, 40));
          rows.push(print.twoColumn(`${transaction?.note_credit}`, `${formatRupiah(transaction?.grand_total)}`, 17, 6, 17));
          rows.push(print.oneLine(`-----------`, 40, 'right'));
          rows.push(print.twoColumn(`Penerimaan :`, `${formatRupiah(transaction?.grand_total)}`, 17, 6, 17));
          rows.push(print.breakLine(40, " "));
          rows.push(print.twoColumn(`Penerimaan :`, `${formatRupiah(transaction?.grand_total)}`, 17, 6, 17));
          rows.push(print.twoColumn(`Total Piutang :`, `${formatRupiah(transaction?.grand_total)}`, 17, 6, 17));
          rows.push(print.oneLine(`-----------`, 40, 'right'));
          rows.push(print.twoColumn(`Sisa :`, `0`, 17, 6, 17));

          rows.push(print.breakLine(40, "="));

          rows.push(`Jam Cetak: \t ${new Date().toLocaleString()}`);
          rows.push("\n\n\n"); // Extra lines for paper cut
          printerText = rows.join("\n");
          return printerText;
        } catch (error) {
          console.error('Gagal mencetak tagihan.', error);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Gagal mencetak tagihan.', life: 3000 });
        }
      },
      async printBillCredit(transaction) {
        try {

          // Convert the element to text format suitable for ESC/POS
          const printerText = await this.formatBillCredit(transaction);
          console.log("printerText:", printerText);

          // Send to backend printer endpoints
          const print_url =
            process.env.VUE_APP_ROOT_API + "/printer/printing/custom-print";

          const response = await axios.post(print_url, {
            text: printerText,
            printer_ip: process.env.VUE_APP_CASIER_IP,
          });

          // Optional: Show success message
          console.log("Print job sent successfully", response);
        } catch (error) {
          console.error("Print error:", error);
          this.errorMessage = "Failed to print: " + error.message;
          this.showErrorDialog = true;
        }
      },
      closeModalPelunasan() {
        this.modalShowPelunasan = false
      },
      countPeriode(allSalesOrders) {
        // Group sales orders by date
        const salesByDay = allSalesOrders?.reduce((acc, order) => {
          if (!order?.createdAt) return acc;
          const date = order.createdAt.split('T')[0]; // Extract YYYY-MM-DD from ISO string
          if (!acc[date]) {
            acc[date] = [];
          }
          acc[date].push(order);
          return acc;
        }, {});

        // Calculate total days with sales
        const totalSalesDays = Object.keys(salesByDay || {}).length || 0;

        // Get all unique dates
        const allDates = Object.keys(salesByDay || {}).sort();
        const dateRange = allDates.length > 0 ? [allDates[0], allDates[allDates.length - 1]] : [];

        return {
          dateRange,
          totalSalesDays
        };
      },
      async printAccountsReceivableReport() {
        try {
          let params = {};

          if (this.filter.capacity) {
            params.capacity = this.filter.capacity;
          }

          if (this.filter.type) {
            params.order_type = this.filter.type;
          }

          if (this.filter.status) {
            params.is_paid_off = this.filter.status === '1' ? true : false;
          }

          if (this.filter.marketing_id) {
            params.marketing_id = this.filter.marketing_id;
          }

          if (this.filter.payment_method_id) {
            params.payment_method_id = this.filter.payment_method_id;
          }

          if (this.filter.table_id) {
            params.table_id = this.filter.table_id;
          }

          if (this.filter.cash_register_id) {
            params.cash_register_id = this.filter.cash_register_id;
          }

          if (this.filter.rangeDate) {
            const start_date = this.formateISODate(this.filter.rangeDate[0]);
            const end_date = this.formateISODate(this.filter.rangeDate[1]);
            params.start_date = start_date;
            params.end_date = end_date;
            params.date_column = 'createdAt';
          }

          params.is_credit = true;

          const data = await this.$store.dispatch('sales_orders/fetchSalesOrders', { ...params, limit: null });
          const { dateRange } = this.countPeriode(data?.data);
          console.log("dateRange:", dateRange);
          const reportData = data?.data?.map(
            (item, index) => ({
              no: index + 1,
              code: item.code,
              marketing: this.allMarketings?.find(m => m.id == item.marketing_id)?.name || "-",
              customer_name: item.customer_name,
              transaction_date: item.transaction_date,
              due_date: this.formatDate(item?.updatedAt),
              grand_total: this.formatRupiah(Number(item.grand_total)),
              paid_amount: item?.is_paid_off ? this.formatRupiah(Number(item.grand_total)) : this.formatRupiah(0),
              remaining: item?.is_paid_off ? this.formatRupiah(0) : this.formatRupiah(Number(item.grand_total)),
              status: item?.is_paid_off ? 'PAID' : 'NOT PAID'
            })
          );
          const tableHeader = [
            { header: 'No', dataKey: 'no' },
            { header: 'Kode', dataKey: 'code' },
            { header: 'Nama Pelanggan', dataKey: 'customer_name' },
            { header: 'Marketing', dataKey: 'marketing' },
            { header: 'Total', dataKey: 'grand_total' },
            { header: 'Terbayar', dataKey: 'paid_amount' },
            { header: 'Balance', dataKey: 'remaining' },
            { header: 'Tanggal Bayar', dataKey: 'due_date' },
            { header: 'Status', dataKey: 'status' }
          ];

          const summary = [
            { label: 'Total Piutang', value: this.formatRupiah(data?.data?.reduce((total, item) => total + Number(item.grand_total), 0)) },
            { label: 'Total Terbayar', value: this.formatRupiah(data?.data?.filter(item => item.is_paid_off).reduce((total, item) => total + Number(item.grand_total), 0)) },
            { label: 'Total Sisa', value: this.formatRupiah(data?.data?.filter(item => !item.is_paid_off).reduce((total, item) => total + Number(item.grand_total), 0)) }
          ];

          const tableColumnStyle = {
            0: { cellWidth: 6 },   // No
            1: { cellWidth: 16 },  // Kode
            2: { cellWidth: 25 },  // Nama Pelanggan
            3: { cellWidth: 25 },  // Marketing
            4: { cellWidth: 25 },  // Tgl Bayar
            5: { cellWidth: 25, halign: 'right' },  // Total
            6: { cellWidth: 25, halign: 'right' },  // Terbayar
            7: { cellWidth: 25, halign: 'right' },  // Sisa
            8: { cellWidth: 16, halign: 'center' }  // Status
          };

          printPdf.generateAccountsReceivableReport(
            {
              tableHeader,
              reportData,
              summary,
              tableColumnStyle
            }, {
            title: 'LAPORAN PIUTANG',
            companyName: process.env.VUE_APP_STORE_NAME || 'Xixi Lounge & KTV',
            companyAddress: process.env.VUE_APP_STORE_ADDRESS || 'Jl. Tidar No. 350',
            startDate: dateRange ? dateRange[0] : '-', // Set your start date
            endDate: dateRange ? dateRange[1] : '-', // Current date
            fontSizeTable: 6
          }
          );
        } catch (error) {
          console.error('Gagal mencetak tagihan.', error);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Gagal mencetak tagihan.', life: 3000 });
        }
      }
    },
  };
</script>
